<template>
<div class="main-content" :style="mainContentViewHeight">
    <el-tabs v-if="!hideTabs" v-model="activeName" @tab-click="tableChange">
      <el-tab-pane label="数据集基本信息" name="basicInfo">
        <config-basic-info v-if="isRouterAlive" :dataSetId.sync="dataSetId"/>
      </el-tab-pane>
      <el-tab-pane label="字段配置" name="datasetFields">
        <config-itemlist v-if="isRouterAlive" :dataSetId.sync="dataSetId"/>
      </el-tab-pane>
      <el-tab-pane label="表结构" name="tableiInfo">
        <config-table-info v-if="isRouterAlive" ref="configTableInfoRef" :dataSetId.sync="dataSetId"/>
      </el-tab-pane>
    </el-tabs>
    <div v-if="hideTabs">
      <el-alert
        title="请选择数据集！"
        type="success"
        :closable="false">
      </el-alert>
    </div>
  </div>
</template>

<script>
    import ConfigBasicInfo from './table_config_basicinfo'
    import ConfigTableInfo from './table_config_tableinfo'
    import ConfigItemlist from './table_config_column_list'

    export default {
    props: ['mainContentViewHeight'],
    data() {
      return {
        activeName: 'basicInfo',
        dataSetId: '',
        isRouterAlive: true
      }
    },
    computed: {
      hideTabs: {
        get() {
          return this.dataSetId === undefined || this.dataSetId === ''
        }
      }
    },
      activated() {
          this.dataSetId = this.$route.params.id
          this.loadData()
      },
      created() {


    },
    components: {
      ConfigBasicInfo,ConfigItemlist,ConfigTableInfo
    },
    methods: {
      loadData() {
        this.activeName = 'basicInfo'
      },
      tableChange(tab, event) {
        this.activeName = tab.name

        if(this.activeName == "tableiInfo"){
          const that = this
          setTimeout(function(){
            that.$refs.configTableInfoRef.initEditor()
          },100)
        }else{
          this.$refs.configTableInfoRef.breakEditor();
        }
      },
      reload () {
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      }
    },
    watch:{
      $route(to,from){
          if(window.location.href.indexOf('table_config')!= -1){
              this.dataSetId = this.$route.params.id
             this.reload();
          }
      }
    }
  }
</script>
